import { RouteObject } from "react-router-dom";
import { ValidatedRoutes } from "@components/PermissionedRoutes";

export const WIRE_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { WireManager } = await import("./WireManager");
      return { element: <WireManager /> };
    },
  },
  {
    path: "ai_search",
    element: (
      <ValidatedRoutes
        validate={(userConfiguration) => {
          const { isFeatureEnabled, permissions } = userConfiguration;
          return (
            isFeatureEnabled("command_ai_search", "wire_manager") &&
            permissions.includes("backoffice.use_ai_search")
          );
        }}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { AiSearch } = await import("./ai_search/AiSearch");
          return { element: <AiSearch /> };
        },
      },
      {
        path: ":threadId",
        async lazy() {
          const { WireManagerAiThread } = await import("./ai_search/AiThread");
          return { element: <WireManagerAiThread /> };
        },
      },
    ],
  },
];
